<!--
  *  对话布局
-->
<template>
    <div class="chat-watermark" :style="watermarkStyle">
        <Splitpanes class="default-theme" style="background: transparent !important;" v-if="chatModel == 1">
            <Pane size="20" style="background: transparent !important;">
                <Left />
            </Pane>
            <Pane size="20" style="border:2px solid rgba(223, 229, 244, 0.8); border-radius: 10px;">
                <Middle />
            </Pane>
            <Pane size="40"
                style="background: transparent !important;border:2px solid rgba(223, 229, 244, 0.8); border-radius: 10px;">
                <!-- 主内容区 -->
                <router-view id="mainBox" style="flex-shrink: 1;"
                    class="nt__mainbox flex2 flexbox flex-col"></router-view>
            </Pane>
            <Pane size="20" style="background: transparent !important;">
                <SidebarRight id="rightBox"
                    style="box-sizing: border-box; height: 100%; overflow: hidden;flex-grow: 1;flex-shrink: 1;width:100%"
                    class="flex1;" />
            </Pane>
        </Splitpanes>
        <Splitpanes class="default-theme" style="background: transparent !important;" v-else>
            <Pane size="20" style="background: transparent !important;">
                <LeftCtrl />
            </Pane>
            <!-- <Pane size="20" style="border:2px solid rgba(223, 229, 244, 0.8); border-radius: 10px;">
                <Middle />
            </Pane> -->
            <Pane size="40"
                style="background: transparent !important;border:2px solid rgba(223, 229, 244, 0.8); border-radius: 10px;">
                <!-- 主内容区 -->
                <router-view id="mainBox" style="flex-shrink: 1;"
                    class="nt__mainbox flex2 flexbox flex-col"></router-view>
            </Pane>
            <Pane size="20" style="background: transparent !important;">
                <SidebarRight id="rightBox"
                    style="box-sizing: border-box; height: 100%; overflow: hidden;flex-grow: 1;flex-shrink: 1;width:100%"
                    class="flex1;" />
            </Pane>
        </Splitpanes>
    </div>
</template>
<script setup>
import { watch, computed, inject, onMounted, ref, onUnmounted } from 'vue'
import { Splitpanes, Pane } from 'splitpanes/dist/splitpanes.es.js'
import { useStore } from "vuex";
import Left from './left/index.vue'
import LeftCtrl from './leftctrl/index.vue'
import Middle from './middle/index.vue'
import SidebarRight from './sidebarRight/index.vue'
const utils = inject('utils')
const momentUtil = inject("momentUtil");

/**
 * 对话模式，控制台模式/平台模式
 */
const chatModel = computed(() => {
    return store.state.chat_store.chat_model
})

const dateTime = ref(momentUtil.moment().format('YYYY-MM-DD HH:mm:ss'))
const store = useStore();
const userInfo = computed(() => {
    return store.state.user.user;
});
const timmer = ref(undefined)


const updateDateTime = async () => {
    if (timmer.value) {
        clearTimeout(timmer.value)
    }
    timmer.value = setTimeout(() => {
        dateTime.value = momentUtil.moment().format('YYYY-MM-DD HH:mm:ss');
        updateDateTime()
    }, 60000);

}


const content = computed(() => {
      let account = store.state.user.user?.username || ''
    try {
        let isMobile = utils.checkTel(account)
        if (isMobile) {
            account = account.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2');
        }
        return `${store.state.user.user?.nickname}-${account}（${dateTime.value}）`
    } catch (e) {
        console.error(e)
        return `${store.state.user.user?.nickname}-${account}（${dateTime.value}）`
    }

})

const escapeSvgText = (value) => {
    return `${value}`
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
}

const watermarkStyle = computed(() => {
    const text = escapeSvgText(content.value || '')
    const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="420" height="180" viewBox="0 0 420 180"><text x="40" y="95" fill="rgba(0, 0, 0, .09)" font-size="16" font-family="sans-serif" transform="rotate(-22 210 90)">${text}</text></svg>`
    return {
        '--chat-watermark-image': `url("data:image/svg+xml,${encodeURIComponent(svg)}")`
    }
})

onMounted(async () => {
    dateTime.value = momentUtil.moment().format('YYYY-MM-DD HH:mm:ss');
    updateDateTime()
})

onUnmounted(() => {
    if (timmer.value) {
        clearTimeout(timmer.value)
    }
})
</script>

<style scoped>
.chat-watermark {
    height: 100%;
    position: relative;
}

.chat-watermark::after {
    content: "";
    position: absolute;
    inset: 0;
    z-index: 9;
    pointer-events: none;
    background-image: var(--chat-watermark-image);
    background-repeat: repeat;
    background-size: 420px 180px;
}
</style>
